import axiosIns from '@/plugins/axios'

export default {
  getClubEventTags() {
    return axiosIns.get('/admin/club_event_tags')
  },
}
